import { useContext } from "react"
import { AppContext } from "../../context/AppContext"


export default function PromptTag({ category, handlePromptTag, active }){

    //CONTEXT
    const { capitalizeWords } = useContext( AppContext )

    return(
        <div className={`prompt-tag ${ active ? 'active' : '' } `} onClick={ () => handlePromptTag( category ) }>
            <p>{ capitalizeWords( category ) }</p>
        </div>
    )
}